import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  dateFormatter,
  dropdownFetch,
  getCurrentDateTime,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import { BASE_URL } from '../../../../../utils';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { BANK_CASH, GENDER_DROPDOWN, RECEIPT_MODE, RELATION, TITLES, LAB_BOOKING_TYPE } from '../../../../../constants';
import { useLocation } from 'react-router-dom';
import { IPDSearchHandler } from '../../HMS/transactions/utils';
// import { LabBillingDetailform } from './LabBillingDetailform';
import { CustomButtonn } from '../../../../../components';
import { ServiceBookingDetailForm } from './ServiceBookingDetailForm';

const TABLE_HEADER = [
  {
    header: 'Bill No',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.bill_no}`}
        </span>
      );
    }
  },
  {
    header: 'Bill Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'Patient Name',
    accessor: (row) => `${row.patient_name}`
  },
  {
    header: 'Sponsor',
    accessor: (row) => row?.sponsorDetails[0]?.name
  },
  {
    header: 'Mobile No',
    accessor: 'mobile'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const BILL_TABLE_HEADER = [
  {
    header: 'Service Name',
    accessor: (row) => row?.service_name?.service_name || row?.service_name
  },
  {
    header: 'Qty',
    accessor: 'quantity'
  },
  {
    header: 'Rate',
    accessor: 'rate'
  },
  {
    header: 'Amount',
    accessor: 'amount'
  },
  {
    header: 'Dis. Amt.',
    accessor: 'disc_amt'
  },
  {
    header: 'Net Amt',
    accessor: 'net_amt'
  }
];



const initialInvestiagtionBookingDataObj = {
  data: [],
  loading: false
};

const initialOpdBillingDataObj = {
  data: [],
  loading: false
};

const initialIpdBillingDataObj = {
  data: [],
  loading: false
};

const initialIpdBillingIndentDataObj = {
  data: [],
  loading: false
};
export const ServiceBooking = () => {
  const doctorIDRef = useRef();
  const sponsorIdRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [investigationBookingDataObj, setInvestigationBookingDataObj] = useState(initialInvestiagtionBookingDataObj);
  const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialOpdBillingDataObj);
  const [ipdBillingDataObj, setIpdBillingDataObj] = useState(initialIpdBillingDataObj);
  const [ipdBillingIndentDataObj, setIpdBillingIndentDataObj] = useState(initialIpdBillingIndentDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [guardianDropdown, setGuardianDropdown] = useState([]);
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [referralDropdown, setReferralDropdown] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [searchOpdBillingDialog, setSearchOpdBillingDialog] = useState(false);
  const [searchIpdBillingDialog, setSearchIpdBillingDialog] = useState(false);
  const [searchIpdBillingIndentDialog, setSearchIpdBillingIndentDialog] = useState(false);
  const [serviceDropdown, setSeriveDropdown] = useState([]);
  const [bookingId, setBookingId] = useState(null);
  const user = JSON.parse(localStorage.getItem('user'));
  const netAmtRef = useRef(0);
  const [input, setInput] = useState('');
  const [patientType, setPatientType] = useState('');

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        patient_name: Yup.string().required('Please Enter Patient Name'),
        mobile: Yup.string()
          .required('Mobile  number is required')
          .matches(/^\d{10}$/, 'Mobile number must be exactly 10digits'),
        bill: Yup.object().shape({
          pay_mode: Yup.string().required(' ')
        })
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      patient_suffix: 'Mr.',
      gender: 'Male',
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;
  const { getValues } = useForm();
  const discAmt = watch('bill.disc_amt'); // Watch discount amount
  const netAmtWatch = watch('bill.net_amt'); // Watch net amount
  const recAmt1Watch = watch('bill.rec_amt_1');
  const recAmt2Watch = watch('bill.rec_amt_2');
  const payMode = watch('bill.pay_mode');
  const discPer = watch('bill.disc_per'); // Watch discount percentage

  // Calculate the initial values from the detailList
  useEffect(() => {
    let total_qty = 0;
    let total_amt = 0;
    let gst_amt = 0;
    let net_amt = 0;

    if (detailList) {
      detailList.forEach((detail) => {
        total_qty += detail.quantity;
        total_amt += detail.amount;
        gst_amt += detail.gst_amt;
        net_amt += detail.net_amt;
      });
    }

    // Set initial values for total amount, net amount, and other fields
    setValue('bill.total_qty', total_qty);
    setValue('bill.total_amt', total_amt);
    setValue('bill.gst_amt', gst_amt);
    setValue('bill.net_amt', net_amt); // Set the initial net_amt from the detailList
    netAmtRef.current = net_amt; // Store initial net_amt in useRef
  }, [detailList, setValue]);

  // Handle discount changes and adjust the net amount
  useEffect(() => {
    if (discAmt && netAmtWatch) {
      const adjustedNetAmt = netAmtRef.current - discAmt; // Subtract the discount from the initial net amount

      // Update the fields with the adjusted values
      setValue('bill.net_amt', adjustedNetAmt); // Update net_amt after discount
      setValue('bill.rec_amt_1', adjustedNetAmt); // Set rec_amt_1 to the adjusted net amount
      setValue('bill.total_recpt', adjustedNetAmt); // Set total_recpt to the adjusted net amount

      // Calculate and set the discount percentage
      const calculatedDiscPer = ((discAmt / netAmtRef.current) * 100).toFixed(2); // Calculate discount percentage
      setValue('bill.disc_per', parseFloat(calculatedDiscPer)); // Update disc_per with calculated value
    }
  }, [discAmt, netAmtWatch, setValue]);

  // Handle receipt and balance amount calculation based on payment mode
  useEffect(() => {
    const total_recpt = +recAmt1Watch + +recAmt2Watch;
    let balanceAmt = netAmtWatch - total_recpt;

    if (payMode === 'CASH') {
      setValue('bill.rec_amt_1', netAmtWatch); // Set the total net amount after discount to rec_amt_1
      setValue('bill.rec_amt_2', 0); // Clear rec_amt_2
      setValue('bill.balance_amt', 0); // Set balance amount to 0
      setValue('bill.total_recpt', netAmtWatch); // Set total receipt to net amount after discount
    } else if (['Bank', 'UPI', 'Paytm', 'RTGS/NEFT/Cheque', 'Credit Card', 'Debit Card'].includes(payMode)) {
      setValue('bill.rec_amt_1', 0); // Clear rec_amt_1 for non-cash payment modes
      setValue('bill.rec_amt_2', netAmtWatch); // Set the total net amount after discount to rec_amt_2
      setValue('bill.balance_amt', 0); // Set balance amount to 0
      setValue('bill.total_recpt', netAmtWatch); // Set total receipt to net amount after discount
    } else if (payMode === 'Credit') {
      setValue('bill.rec_amt_1', 0); // Clear rec_amt_1 for credit payment
      setValue('bill.rec_amt_2', 0); // Clear rec_amt_2 for credit payment
      setValue('bill.balance_amt', balanceAmt); // Set balance amount to remaining balance
      setValue('bill.total_recpt', 0); // Set total receipt to 0 since no payment is made
    } else {
      // Default case when no payment mode is matched
      setValue('bill.total_recpt', total_recpt);
      setValue('bill.balance_amt', balanceAmt);
    }
  }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);

  useEffect(() => {
    if (selectedRecord) {
        console.log(selectedRecord,"HELLO SELECTED RECORD")
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setValue('bill_no',selectedRecord?.bill_no)
      setValue('patient_suffix', selectedRecord.patient_suffix);
      setValue('patient_name', selectedRecord.patient_name);
      setValue('mobile', selectedRecord.mobile);
      setValue('address', selectedRecord.address);
      setValue('ref_by', selectedRecord.ref_by);
      setValue('doctor', selectedRecord.doctor);
      setValue('remarks', selectedRecord.remarks);
      setValue('address', selectedRecord.address);
      setValue('guardian_type', selectedRecord.guardian_type);
      setValue('guardian_name', selectedRecord.guardian_name);
      setValue('age', selectedRecord.age);
      const formattedbillDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedbillDate);
      setValue('time', selectedRecord?.billing_time);
      setDetailList(selectedRecord.service_items);
      // searchPatientHandler(selectedRecord.uhid);
    } else {
      reset();
    }
  }, [selectedRecord]);

  console.log(selectedRecord,"SELECTED RECORD")
  const getServiceDropdown = useCallback(async () => {
    const data = await dropdownFetch('service');
    setSeriveDropdown(data);
    setPatientDetailList(data);
  }, []);

  useEffect(() => {
    getServiceDropdown();
  }, [getServiceDropdown]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    if (detailList.length === 0) {
      toast('Please add the Test first', { variant: 'warning' });
      return;
    }
    const payload = {
      ...formValues,
      ...formValues.bill,
      bookingId,
      uhid: formValues.uhid,
      ipd_no: formValues.ipd_no,
      service_items: detailList,
      indent_no: formValues.indent_no,
      date: formValues.date,
      time: formValues.time
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/radiology-service-booking-edit' : '/radiology-service-booking-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Radiology Service Booking `, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction("");
      setDetailList([]);
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'}Radiology Service Booking`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleRowDelete = (rowId) => {
    console.log('HELLO DETAIL LIST', detailList);
    setDetailList((prev) => prev.filter((data) => data.service !== rowId));
  };

  const onDetailAddHandler = (data) => {
    const existingDetail = detailList.find(({ service }) => service === data.service);
    if (existingDetail) {
      toast('Test is already chosen', { variant: 'error' });
      return;
    }
    const serviceName = serviceDropdown.find(({ _id }) => _id === data.service)?.service_name;
    if (!serviceName) {
      toast('Service name not found', { variant: 'error' });
      return;
    }
    setDetailList((prev) => [
      ...prev,
      {
        ...data,
        service_name: serviceName
      }
    ]);
    toast(`Test Added Successfully `, { variant: 'success' });
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/radiology-service-booking-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Booking', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Booking', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/radiology-service-booking-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Booking', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Booking', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setInvestigationBookingDataObj({ loading: true });
    const response = await axios.get(`${BASE_URL}/radiology-service-booking/list?limit=${10}`);
    if (response.data.success) {
      const filteredData = response.data.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      const sortedData = filteredData.sort((a, b) => b.bill_no - a.bill_no);
      setInvestigationBookingDataObj({ loading: false, data: sortedData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setInvestigationBookingDataObj({ loading: false });
    }
  };

  const searchPatientHandler = async (uhid = null) => {
    if (typeof uhid !== 'number' && typeof uhid !== 'string') uhid = null;
    setLoading(true);

    if (!uhid) setSearchPatientRegisterationDialog(true);

    const response = await request('/patient-registeration-search', { method: 'GET', query: { uhid } });

    if (response?.success) {
      // Sort the data by app_no_date (assumed to be a date string or Date object)
      const sortedPatientData = response?.data.sort((a, b) => {
        const dateA = new Date(a.date); // Convert to Date object
        const dateB = new Date(b.date); // Convert to Date object
        return dateB - dateA; // Sort in ascending order. For descending, use: return dateB - dateA;
      });

      if (uhid) {
        const {
          data: [patientData]
        } = response;

        setValue('patient_name', `${patientData.first_name} ${patientData.last_name}`);
        setValue('patient_suffix', patientData.name_suffix);
        setValue('opd_type', patientData.opd_type?.type);
        setValue('ref_type', patientData.ref_by?.referral_name);
        setValue('application_no', patientData.app_no_date);
        setValue('doctor', patientData.consultant?.name);
        doctorIDRef.current = patientData.consultant?._id;
        setValue('department', patientData.department?.department);
        setValue('sponsor', patientData.sponsor?.name);
        sponsorIdRef.current = patientData.sponsor?._id;
        setValue('remarks', patientData.remarks);
        setValue('queue_no', patientData.app_no_date);
        setValue('card_no', patientData.chq_card_no);
        setValue('vertical', patientData.vertical?.verticalname);
        setValue('address', patientData.address.address);
      } else {
        setPatientDetailList(sortedPatientData);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }

    setLoading(false);
  };

  const searchIPDDetails = async (ipd_no) => {
    setLoading(true);
    const response = await request('/indoor-registeration-detail', {
      method: 'GET',
      params: ipd_no
    });
    if (response?.success) {
      if (!response?.data) {
        toast('No IPD found', { variant: 'warning' });
      } else {
        const { data: patientData } = response;
        console.log('HELLO DATATA', patientData);
        setValue('ipd_no', ipd_no);
        setValue('patient_name', `${patientData.patient.first_name} ${patientData.patient.last_name}`);
        setValue('patient_suffix', patientData.patient.name_suffix);
        setValue('ward', patientData.consultant_detail.room?.ward?.name);
        setValue('uhid', patientData.uhid);
        doctorIDRef.current = patientData.patient.consultant?._id;
        setValue('doctor', patientData.patient.consultant?._id);
        setValue('guardian_name', patientData.patient.guardian_name);
        setValue('guardian_type', patientData.patient.guardian_type);
        setValue('room_no', patientData.consultant_detail?.room?.room_no);
        setValue('bed_no', patientData.consultant_detail?.bed_no);
        setValue('sponsor', patientData.patient.sponsor?._id);
        sponsorIdRef.current = patientData.patient.sponsor?._id;
        setPatientType('IPD');
        setValue('address', patientData.patient.address?.address);
        setValue('country', patientData.patient.address?.country);
        setValue('state', patientData.patient.address?.state);
        setValue('city', patientData.patient.address?.city);
        setValue('aadhar', patientData.patient.address?.aadhar);
        setValue('mobile', patientData.patient.address?.mobile);
        setValue('email', patientData.patient.address?.email);
        setValue('gender', patientData.patient.gender);
        setValue('ref_by', patientData.patient.ref_by.refferal_name?._id);
        setValue('dob', formatDate(patientData.patient.dob));
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;
    return `${formattedDay}-${formattedMonth}-${year}`;
  };

  const paymentMode = watch('bill.pay_mode');
  const balanceAmt = watch('bill.balance_amt');
  const [tempBalanceAmt, setTempBalanceAmt] = useState(balanceAmt);

  useEffect(() => {
    if (paymentMode === 'CASH') {
      setTempBalanceAmt(balanceAmt);
    }
  }, [paymentMode, balanceAmt]);

  useEffect(() => {
    if (paymentMode === 'CASH' && tempBalanceAmt !== 0) {
      setValue('bill.bank_cash', 'CASH');
      setValue('bill.total_recpt', tempBalanceAmt);
      setValue('bill.rec_amt_1', tempBalanceAmt);
      setValue('bill.balance_amt', 0);
    } else {
      console.log('select paymode');
    }
  }, [paymentMode, tempBalanceAmt, setValue]);

  const getGuardianDropdown = useCallback(async () => {
    const data = await dropdownFetch('relation-master');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('guardian_type', defaultState?._id);
    }
    setGuardianDropdown(data);
  }, []);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    if (!selectedRecord) {
      const [defaultSponsor] = data.filter(({ status }) => status === 'default');
      setValue('sponsor', defaultSponsor?._id);
    }
    setSponsorDropdown(data);
  }, []);

  const getReferralDropdown = useCallback(async () => {
    const data = await dropdownFetch('referral');
    if (!selectedRecord) {
      const [defaultReferal] = data.filter(({ status }) => status === 'default');
      setValue('ref_by', defaultReferal?._id);
    }
    setReferralDropdown(data);
  }, []);

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('consultant')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }

    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  useEffect(
    () => {
      getGuardianDropdown();
      getSponsorDropdown();
      getReferralDropdown();
      getDoctorDropdown();
    },
    getGuardianDropdown,
    getSponsorDropdown,
    getReferralDropdown,
    getDoctorDropdown
  );

  const uhid = watch('uhid');
  const ipd_no = watch('ipd_no');

  const bookingModeWatch = watch('booking_mode');

  const handlefetchOpdBilling = async () => {
    setSearchOpdBillingDialog(true);
    setOpdBillingDataObj({ loading: true });
    const response = await request('/opd-billing-investigation-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
      const filteredData = sortedData
        .map((item) => {
          const filteredServiceItems = item.service_items.filter((service) => service.type === 'L');
          return filteredServiceItems.length > 0 ? { ...item, service_items: filteredServiceItems } : null;
        })
        .filter((item) => item !== null)
        .filter((item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default');
      setOpdBillingDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOpdBillingDataObj({ loading: false });
    }
  };

  console.log('BOOKING ID', bookingId);

  const handlefetchIpdBilling = async () => {
    setSearchIpdBillingDialog(true);
    setIpdBillingDataObj({ loading: true });
    const response = await request('/ipd-billing-investigation-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
      const filteredData = sortedData
        .map((item) => {
          const filteredServiceItems = item.service_items.filter((service) => service.type === 'L');
          return filteredServiceItems.length > 0 ? { ...item, service_items: filteredServiceItems } : null;
        })
        .filter((item) => item !== null)
        .filter((item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default');
      setIpdBillingDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIpdBillingDataObj({ loading: false });
    }
  };

  const handlefetchIpdBillingIndent = async () => {
    setSearchIpdBillingIndentDialog(true);
    setIpdBillingIndentDataObj({ loading: true });
    try {
      const [billingResponse, investigationResponse] = await Promise.all([
        request('/ipd-billing-investigation-list', { method: 'GET' }),
        request('/investigation-booking-list', { method: 'GET' })
      ]);
      if (billingResponse.success && investigationResponse.success) {
        const investigationIndentNos = new Set(investigationResponse.data.map((item) => item.indent_no));
        const sortedData = billingResponse.data.sort((a, b) => new Date(b.date) - new Date(a.date));
        const filteredData = sortedData
          .filter((item) => item.indent_no && !investigationIndentNos.has(item.indent_no))
          .map((item) => {
            const filteredServiceItems = item.service_items.filter((service) => service.type === 'L');
            return filteredServiceItems.length > 0 ? { ...item, service_items: filteredServiceItems } : null;
          })
          .filter((item) => item !== null)
          .filter((item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default');

        setIpdBillingIndentDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data from one or both sources', { variant: 'error' });
        setIpdBillingIndentDataObj({ loading: false });
      }
    } catch (error) {
      toast('Error in fetching data', { variant: 'error' });
      setIpdBillingIndentDataObj({ loading: false });
    }
  };

  useEffect(() => {
    handleUhidSearch(input);
  }, [input]);

  const handleUhidSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    
      try {
        const response = await request('/radiology-service-booking-list', {
          method: 'GET',
          query: { patient_name: lowercasedInput }
        });
        if (response.success && Array.isArray(response.data)) {
          setInvestigationBookingDataObj({ loading: false, data: response.data });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setInvestigationBookingDataObj({ loading: false, data: [] });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setInvestigationBookingDataObj({ loading: false, data: [] });
      }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };


  const sponsor = watch('sponsor')
  console.log(sponsor,"HELLLO SPONSOR")


useEffect(() => {
  doctorIDRef.current = watch('doctor');
}, [watch('doctor')]);

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Service Booking
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setPatientDetailList([]);
                    setDetailList([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                    reset();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <SelectTag
                      name="patient_suffix"
                      formControlSX={{ flex: 0.2 }}
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                      menus={TITLES}
                    />
                    <TextField
                      name="patient_name"
                      sx={{ flex: 0.6 }}
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Gender/Age</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.4 }}
                      name="gender"
                      menus={GENDER_DROPDOWN}
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                    />
                    <TextField
                      name="age"
                      sx={{ flex: 0.4 }}
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="sponsor"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      menus={sponsorDropdown}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ref By</Typography>
                    <SelectTag
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="ref_by"
                      menus={referralDropdown.map((data) => ({ ...data, name: data.referral_name }))}
                    />
                  </Stack>     
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bill No</Typography>
                    <TextField disabled={true} sx={{ flex: 0.8 }} placeholder="Bill No."  name="bill_no" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mobile No</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      name="mobile"
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                     type="number"
                    error={!!methods.formState.errors.mobile}
                    helperText={
                    methods.formState.errors.mobile ? methods.formState.errors.mobile.message : ''
                    }
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor Name</Typography>
                    <SelectTag
                      menus={doctorDropdown}
                      formControlSX={{ flex: 0.8 }}
                      name="doctor"
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}> Date/Time/Sno</Typography>
                    <TextField sx={{ flex: 0.3 }} name="date" type="date" disabled />
                    <TextField sx={{ flex: 0.3 }} name="time" type="time" disabled />
                    <TextField sx={{ flex: 0.2 }} name="s_no" disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Guardian</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.2 }}
                      name="guardian_type"
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                      menus={guardianDropdown}
                    />
                    <TextField
                      sx={{ flex: 0.6 }}
                      name="guardian_name"
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      name="address"
                      disabled={uhid || ipd_no ? true : !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                    <TextField sx={{ flex: 0.8 }} name="remarks" disabled={!['new', 'edit'].includes(currentAction)} />
                  </Stack>
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Stack spacing={1} direction="row" justifyContent="end">
                    <Button
                      variant="outlined"
                      disabled={!['new', 'edit'].includes(currentAction)}
                      onClick={() => setAddDetailsDialogOpen(true)}
                    >
                      Add Details
                    </Button>
                  </Stack>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid grey' }}
                    data={detailList.map((data) => ({ _id: data.service, ...data }))}
                    columns={BILL_TABLE_HEADER}
                    size="small"
                    showDeleteAction={true}
                    onDeleteHandler={handleRowDelete}
                  />
                </Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Payment Mode</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      name="bill.pay_mode"
                      menus={RECEIPT_MODE}
                      onChange={() => setValue('bank_cash', '')}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Auth Code</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="bill.auth_code"
                      placeholder="Auth Code"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Qty/Amt</Typography>
                    <TextField disabled sx={{ flex: 0.3 }} name="bill.total_qty" placeholder="Qty" />
                    <TextField disabled sx={{ flex: 0.5 }} name="bill.total_amt" placeholder="Amt" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Disc Per/ Amt</Typography>
                    <TextField disabled sx={{ flex: 0.4 }} name="bill.disc_per" placeholder="Disc. %" />
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || !watch('bill.pay_mode')}
                      sx={{ flex: 0.4 }}
                      name="bill.disc_amt"
                      placeholder="Disc. Amt"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Net Amt</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.net_amt" placeholder="Net Amount" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>RecAmt 1&2</Typography>
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      inputProps={{ min: '0' }}
                      name="bill.rec_amt_1"
                      placeholder="Amt 1"
                    />
                    <TextField
                      sx={{ flex: 0.4 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      type="number"
                      inputProps={{ min: '0' }}
                      name="bill.rec_amt_2"
                      placeholder="Amt 2"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Recpt.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.total_recpt" placeholder="Total" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Balance Amt</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bill.balance_amt" placeholder="Balance Amount" />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={addDetailsDialogOpen}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '90vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
      </Dialog>  

      <Dialog
        open={addDetailsDialogOpen}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '90vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <ServiceBookingDetailForm
          chargeType="ipd_charges"
          onClose={() => setAddDetailsDialogOpen(false)}
          onAdd={onDetailAddHandler}
          sponsorID={sponsor}
          patientType={patientType}
          doctorID={doctorIDRef.current}
        />
      </Dialog>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
           Service Booking Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={investigationBookingDataObj.data || []}
          loading={investigationBookingDataObj.loading}
          onRowClick={(row) => {
            delete row.patient;
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
